import React from "react";
import { Link } from "react-router-dom";
import { RiFacebookFill, RiWhatsappFill, RiDiscordFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// interface SocialMediaData {
//   [key: string]: string;
// }

interface SocialMediaIconsProps {
  socialMediaData?: any;
  iconSize?: string;
  containerClass?: string;
  showOnlyAvailable?: boolean;
  backgroundColor?: string;
  textColor?: string;
  onClick?: (platform: string) => void;
}

interface SocialMediaPlatform {
  icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  key: string;
  displayKey?: string;
}

const SocialMediaIcons: React.FC<SocialMediaIconsProps> = ({
  socialMediaData = {},
  iconSize = "btn-size-20",
  containerClass = "icon-container",
  showOnlyAvailable = true,
  backgroundColor,
  textColor,
  onClick,
}) => {
  const socialMediaIcons: { [key: string]: SocialMediaPlatform } = {
    facebook: {
      icon: RiFacebookFill,
      key: "facebook",
      displayKey: "Facebook",
    },
    instagram: {
      icon: AiFillInstagram,
      key: "instagram",
    },
    telegram: {
      icon: FaTelegramPlane,
      key: "telegram",
    },
    x: {
      icon: FaXTwitter,
      key: "x",
      displayKey: "x",
    },
    youtube: {
      icon: AiFillYoutube,
      key: "youtube",
    },
    discord: {
      icon: RiDiscordFill,
      key: "discord",
    },
    twitch: {
      icon: FaTwitch,
      key: "twitch",
    },
    whatsapp: {
      icon: RiWhatsappFill,
      key: "whatsapp",
    },
  };

  const renderIcon = (platform: SocialMediaPlatform) => {
    const Icon = platform.icon;
    const displayKey = platform.displayKey || platform.key;
    const url = socialMediaData[displayKey] || socialMediaData[platform.key];

    if (showOnlyAvailable && (typeof url !== "string" || url === "")) {
      return null;
    }

    const iconStyle: React.CSSProperties = {
      color: textColor || "#fff",
      ...(backgroundColor && { backgroundColor }),
    };

    const iconElement = <Icon className={iconSize} style={iconStyle} />;

    if (url) {
      return (
        <div className={containerClass} key={platform.key} style={iconStyle}>
          <Link
            target="_blank"
            to={typeof url === "string" && url.startsWith("//") ? url : `//${url}`}
          >
            {iconElement}
          </Link>
        </div>
      );
    }

    return (
      <div
        className={containerClass}
        key={platform.key}
        style={iconStyle}
        onClick={() => onClick && onClick(platform.key)}
      >
        {iconElement}
      </div>
    );
  };

  return (
    <div className="d-flex justify-content-center">
      {Object.values(socialMediaIcons).map(renderIcon)}
    </div>
  );
};

export default SocialMediaIcons;
